import { Button, Flex, Text } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
export default function FooterComponent() {
  const navigate = useNavigate();
  return (
    <Flex
      gap="32px"
      direction="column"
      justifyContent="flex-start"
      padding="30px 30px 30px 30px"
      backgroundColor="rgba(233,249,252,1)"
    >
      <Flex
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        alignSelf="stretch"
      >
        <Text
          fontFamily="Inter"
          fontSize="16px"
          fontWeight="400"
          color="rgba(102,112,133,1)"
          lineHeight="24px"
          textAlign="right"
          display="block"
          whiteSpace="pre-wrap"
          children="© 2024 Total Care Compass by Somecos. All rights reserved."
        ></Text>
        <Button
          variation="link"
          size="small"
          padding={1}
          onClick={() => navigate("/user/kb/terms")}
        >
          Terms of Service
        </Button>
        <Button
          variation="link"
          size="small"
          padding={1}
          onClick={() => navigate("/user/kb/privacy")}
        >
          Privacy Policy
        </Button>
        <Button
          variation="link"
          size="small"
          padding={1}
          onClick={() => navigate("/user/kb/disclosure")}
        >
          Disclosure
        </Button>
      </Flex>
    </Flex>
  );
}
